<template>
  <div class="card">
    <Toolbar class="p-mb-4">
      <template #start>
        <Button
          label="Novo"
          icon="pi pi-plus"
          class="mr-2"
          @click="showCreate()"
        />
      </template>
      <template #end>
        <div
          class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-between"
        >
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText
              v-model="filters['global'].value"
              placeholder="Buscar..."
            />
          </span>
        </div>
      </template>
    </Toolbar>
    <DataTable
      ref="dt1"
      dataKey="id"
      class="p-datatable-sm"
      :value="allTipos"
      :paginator="true"
      :rows="5"
      :filters="filters"
      :rowsPerPageOptions="[5, 10, 15]"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      currentPageReportTemplate="Exibindo de {first} a {last} no total de {totalRecords} tipos."
    >
      <template #empty>
        <div class="text-center">Nenhum resultado encontrado...</div>
      </template>
      <Column header="Descrição do Tipo" field="descricao" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.descricao }}
        </template>
      </Column>
      <Column header="Ações">
        <template #body="slotProps">
          <Button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-success mr-2"
            @click="showUpdate(slotProps.data)"
            v-tooltip.top="'CLIQUE PARA EDITAR'"
          />
          <Button
            icon="pi pi-trash"
            class="p-button-rounded p-button-warning"
            @click="showRemove(slotProps.data)"
            v-tooltip.top="'CLIQUE PARA EXCLUIR'"
          />
        </template>
      </Column>
    </DataTable>
  </div>

  <ConfirmDialog></ConfirmDialog>
  <dialog-form :selected="tipo" @findAll="findAll()" />
</template>

<script>
import { FilterMatchMode } from "primevue/api";

//models
import Tipo from "../../models/tipo";

//Services
import TipoService from "../../service/tipo/tipoService";

//components
import DialogForm from "./components/dialog-form.vue";

export default {
  components: {
    DialogForm,
  },
  data() {
    return {
      filters: {},
      allTipos: [],
      tipo: new Tipo(),
      tipoService: new TipoService(),
      loading: false,
    };
  },
  created() {
    this.initFilters();
  },
  mounted() {
    this.findAll();
  },
  methods: {
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    showCreate() {
      this.tipo = new Tipo();
      this.$store.state.views.tipo.dialogForm = true;
    },
    showUpdate(data) {
      this.tipo = { ...data };
      this.$store.state.views.tipo.dialogForm = true;
    },
    showRemove(data) {
      this.tipo = data;
      this.$confirm.require({
        message: "Deseja excluir esse tipo?",
        header: "Deseja deletar?",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim",
        rejectLabel: "Não",
        accept: () => {
          this.tipoService
            .delete(this.tipo.id)
            .then((data) => {
              this.$msgSuccess(data);
              this.findAll();
            })
            .catch((err) => {
              this.loading = false;
              this.$toast.add({
                severity: "error",
                summary: "Alerta de Erro.",
                detail: err,
                life: 6000,
              });
            });
        },
      });
    },
    findAll() {
      this.tipoService.findAll().then((data) => {
        this.allTipos = data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../../App.scss");
</style>
